const language_strings = require(`./generated/${process.env.LOCALE}_ac_strings.json`);
module.exports = language_strings;
